module.exports = __webpack_public_path__ + "img/contrato-825x421.17c22bdc.jpg";